import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const getAttachments = async (params) => {
  try {
    const res = await getRequest({ url: "attachments", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAttachmentBase64 = async (params) => {
  try {
    const res = await getRequest({ url: "attachments/base64", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postAttachment = async (payload) => {
  try {
    const res = await postRequest({ url: "attachments", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putAttachment = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "attachments",
      payload: payload,
      query: { ATTACHMENT_ID: id },
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};
